module.exports = __webpack_public_path__ + "img/actionImg4@2x.11de5b71.jpg";